import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardSidebar from '../components/admin/DashboardSidebar';
import DashboardHeader from '../components/admin/DashboardHeader';
import DashboardHome from '../components/admin/DashboardHome';
import AdminProfile from '../components/admin/AdminProfile';
import Ratings from '../components/admin/Ratings';
import Addresses from '../components/admin/Addresses';
import ManualAddresses from '../components/admin/ManualAddresses';
import MyContractor from '../components/admin/MyContractor';
import MyComments from '../components/admin/MyComments';
import Feedback from '../components/admin/Feedback';
import ContactUs from '../components/admin/ContactUs';
import Reports from '../components/admin/Reports';

import Replies from '../components/admin/Replies';

import Deactivate from '../components/admin/Deactivate';
import LoginHistory from '../components/admin/LoginHistory';
import ActivityLog from '../components/admin/ActivityLog';
import Notifications from '../components/dashboard/Notifications';

import MyProfile from './MyProfile';
import { super_admin_role_id } from '../constant';

const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const role = localStorage.getItem("role");

  return (
    <div className="dashboard-container">
      <DashboardSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className={`dashboard-main ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <DashboardHeader toggleSidebar={toggleSidebar} />
        
        <div className="dashboard-content">
          <Routes>
            <Route path="/" element={<DashboardHome />} />
            {
              role == super_admin_role_id && <Route path="/admin" element={<AdminProfile />} />
            }

            <Route path="/address" element={<Addresses />} />
            <Route path="/manual-address" element={<ManualAddresses />} />
            <Route path="/users/delete" element={<Deactivate />} />

            <Route path="/contractor" element={<MyContractor />} />
            <Route path="/ratings" element={<Ratings />} />
            <Route path="/comments" element={<MyComments />} />
            <Route path="/replies" element={<Replies />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/reports" element={<Reports />} />

            <Route path="/notifications" element={<Notifications />} />
            <Route path="/login-history" element={<LoginHistory />} />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="*" element={<Navigate to="/admin-dashboard/" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 